import React from 'react';
import SidebarStep from './SidebarStep';
import Header from 'modules/views/shared/Header';

import { StepKey } from '../config';
import { useStyles } from '../styles';

interface IDesktopWizardProps {
  steps: Array<{
    title: string;
    content: React.ReactNode;
    isActive?: boolean;
    isCompleted?: boolean;
    fields?: {
      name: string;
      id: string;
      isRequired?: boolean;
      isCompleted?: boolean;
    }[];
    icon: React.ReactNode;
    absoluteStepIndex?: number;
  }>;
  currentStepIndex: number;
  disableNavigation?: boolean;
  onStepChange?: (stepIndex: number) => void;
  sidebarTitle: string;
  sidebarSubtitle: string;
  styleClass?: string;
  contentContainerStyleClass?: string;
  contentStyleClass?: string;
  showOnlineWarning?: boolean;
  Content: React.ReactNode;
}

const DesktopWizard: React.FC<IDesktopWizardProps> = ({
  steps,
  currentStepIndex,
  disableNavigation,
  onStepChange,
  sidebarTitle,
  sidebarSubtitle,
  styleClass,
  contentContainerStyleClass,
  contentStyleClass,
  showOnlineWarning,
  Content,
}) => {
  const classes = useStyles();

  // Render sidebar steps
  const renderSidebarSteps = () =>
    steps.map((step, index) => (
      <SidebarStep
        key={step.absoluteStepIndex ?? index}
        step={step}
        index={step.absoluteStepIndex ?? index} // Use absolute step index for navigation
        currentStepIndex={currentStepIndex}
        disableNavigation={disableNavigation || (step as any).key === StepKey.REGISTRATION}
        onStepChange={onStepChange}
      />
    ));

  return (
    <div className={`${classes.wizardContainer} ${styleClass || ''}`}>
      <div className={classes.sidebar}>
        <div className={classes.sidebarHeader}>
          <p className={classes.sidebarTitle}>{sidebarTitle}</p>
          <p className={classes.sidebarSubtitle}>{sidebarSubtitle}</p>
        </div>
        <div className={classes.sidebarSteps}>{renderSidebarSteps()}</div>
      </div>
      <div
        className={`${classes.contentContainer} ${showOnlineWarning ? classes.contentContainerWithWarning : ''} ${contentContainerStyleClass || ''}`}
      >
        <Header styleClass={classes.header} showOnlineWarning={showOnlineWarning} />
        <div className={`${classes.content} ${contentStyleClass || ''}`}>{Content}</div>
      </div>
    </div>
  );
};

export default DesktopWizard;
